import { PaginationProps } from 'antd';
import useCrud from 'hooks/useCrud';
import { useCallback, useState } from 'react';
import { productList, ProductListParams } from 'services/api/conversation';

function useProduct() {
  const [page, setPage] = useState<PaginationProps>({
    current: 0,
    pageSize: 5,
  });

  const res = useCrud({
    readList: useCallback(
      (paramsOrGetter: ProductListParams | (() => Promise<Conversation.Product[]>)) => {
        if (typeof paramsOrGetter === 'function') {
          return paramsOrGetter().then((res) => {
            setPage({
              current: 0,
              pageSize: 5,
              total: res.length,
            });

            return res;
          });
        }

        return productList(paramsOrGetter).then((res) => {
          const {
            itemList = [],
            pageInfo: { pageNo: current, pageSize, totalCount: total },
          } = res;

          setPage({
            current,
            pageSize,
            total,
          });

          return itemList;
        });
      },
      [],
    ),
  });

  return {
    ...res,
    page,
    setPage,
  };
}

export default useProduct;
